import { Http } from '../../../support';

const initialState = {
  busy: false,
  selectedTab: 'todo',
  filters: {
    page: 1,
    search: '',
  },
  data: [],
  pagination: {
    limit: 25,
  },
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.comprobantes.list = {
      ...state.app.comprobantes.list,
      ...data,
    };
  });
};

const setListData = (store, data) => {
  const { list } = store.state.app.comprobantes;

  const newList = [].concat([data], list.data);

  store.setState((state) => {
    state.app.comprobantes.list = {
      ...state.app.comprobantes.list,
      data: newList,
      pagination: {
        ...state.app.comprobantes.list.pagination,
        count: parseInt(list.pagination.count || 0) + 1,
      },
    };
  });
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.comprobantes.list = {
      ...state.app.comprobantes.list,
      filters: {
        ...state.app.comprobantes.list.filters,
        ...meta,
      },
      pagination: {
        ...state.app.comprobantes.list.pagination,
        limit: meta.limit ?? 25,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.comprobantes.list;
    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
    };

    const response = await Http.get('api/comprobantes', { params });

    store.setState((state) => {
      state.app.comprobantes.list = {
        ...state.app.comprobantes.list,
        pagination: {
          ...state.app.comprobantes.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        busy: false,
        data: response.data,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.comprobantes.list.busy = false;
      state.app.comprobantes.list.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.comprobantes.list = { ...initialState };
  });
};

const ComprobanteListStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    setListData,
    paginate,
    reset,
  },
};

export default ComprobanteListStore;
